export const OTHER_VENDOR_HOUSES_NUMBER = 5
export const HOUSE_CARD_TILE_WIDTH_PX = 224
export const HOUSE_CARD_TILE_HEIGHT = 300
